export default "__VITE_ASSET__5HbavJnv__"